import { Component } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";

import { numberWithSpaces } from "../../../../utilities/formaters";
import moment from "moment";

import { CELL_TYPES } from "../../../../shared/Table";
import { TableCellAccountRedirect } from "../../../../shared/Table/components/Cell";

export class AutogiroCompleteCellComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirmation: false,
      openCancel: false,
    };
  }

  handleConfirm = (accept) => {
    let order = this.props.item;
    if (accept) {
      this.props.completeAutogiroRequest(order);
    } else {
      this.props.cancelPayment(order);
    }
  };

  handleClose = () => {
    this.setState({ openConfirmation: false, openCancel: false });
    this.props.clearAfterActionConfirmMsg();
  };

  openCloseRequest = () => {
    // fetch ssn if it's not fetched
    let snnObj = this.props.ssn[this.props.item.AccountId];
    if (!snnObj || !snnObj.ssnfetched)
      this.props.getSSN(this.props.item.AccountId);

    this.setState({ openCancel: true });
  };

  openConfirmRequest = () => {
    // fetch ssn if it's not fetched
    let snnObj = this.props.ssn[this.props.item.AccountId];
    if (!snnObj || !snnObj.ssnfetched)
      this.props.getSSN(this.props.item.AccountId);

    this.setState({ openConfirmation: true });
  };

  render() {
    let ssnValue = "";
    let snnObj = this.props.ssn[this.props.item.AccountId];
    if (snnObj && snnObj.ssnfetched) ssnValue = snnObj.data.SSN;

    let submitted = !!this.props.autogiroCompleteRequest.msg;

    let discardAction = (
      <Button
        variant="outlined"
        color="primary"
        keyboardFocused={false}
        onClick={this.handleClose}
      >
        {submitted ? "Close" : "Discard"}
      </Button>
    );

    let confirmCancelAction = submitted ? (
      <div />
    ) : (
      <Button
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleConfirm.bind(this, false)}
      >
        Cancel payment
      </Button>
    );

    let confirmAcceptAction = submitted ? (
      <div />
    ) : (
      <Button
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleConfirm.bind(this, true)}
      >
        Confirm paymnet
      </Button>
    );

    let cancelActions = [confirmCancelAction, discardAction];
    let confirmActions = [confirmAcceptAction, discardAction];

    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={this.openCloseRequest}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.openConfirmRequest}
          style={{ margin: "0 10px" }}
        >
          Confirm
        </Button>
        <Dialog
          title="Cancel autogiro request"
          modal={false}
          open={this.state.openCancel}
          onClose={this.handleClose}
        >
          <DialogContent>
            {this.props.autogiroDeleteRequest.msg}
            {this.props.autogiroDeleteRequest.sending ? (
              <CircularProgress />
            ) : undefined}
            <br />
            SSN: {ssnValue ? ssnValue : "Still loading"}
            <br />
            <br />
            Amount: {numberWithSpaces(this.props.item.Amount.Amount)} kr
            <br />
            Date: {moment(this.props.item.Date).format("YYYY-MM-DD")}
          </DialogContent>
          <DialogActions>{cancelActions}</DialogActions>
        </Dialog>
        <Dialog
          title="Confirm autogiro request"
          modal={false}
          open={this.state.openConfirmation}
          onClose={this.handleClose}
        >
          <DialogContent>
            {this.props.autogiroCompleteRequest.msg}
            {this.props.autogiroCompleteRequest.sending ? (
              <CircularProgress />
            ) : undefined}
            <br />
            SSN: {ssnValue ? ssnValue : "Still loading"}
            <br />
            <br />
            Amount: {numberWithSpaces(this.props.item.Amount.Amount)} kr
            <br />
            Date: {moment(this.props.item.Date).format("YYYY-MM-DD")}
          </DialogContent>
          <DialogActions>{confirmActions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

export function getPendingColumns() {
  return [
    {
      key: "AccountId",
      label: "Get ssn",
      filter: false,
      visible: true,
      type: CELL_TYPES.ssn,
    },
    {
      key: "OrderStatus",
      label: "Order status",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "AccountId",
      label: "Account Id",
      type: CELL_TYPES.text,
      visible: true,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    {
      key: "Amount.Amount",
      label: "Repay Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "RequestTimestamp",
      label: "Request Timestamp",
      visible: false,
      type: CELL_TYPES.date,
    },
    { key: "Date", label: "Repay Date", visible: false, type: CELL_TYPES.date },
    { key: "OrderId", label: "Order Id", visible: true },
    {
      key: "action",
      label: "Actions",
      visible: true,
      renderer: (value, item, props) => {
        return <AutogiroCompleteCellComponent {...props} item={item} />;
      },
    },
  ];
}

export function getCompletedColumns() {
  return [
    {
      key: "AccountId",
      label: "Get ssn",
      filter: false,
      visible: true,
      type: CELL_TYPES.ssn,
    },
    {
      key: "AccountId",
      label: "Account Id",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    {
      key: "Amount.Amount",
      label: "Repay Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "RequestTimestamp",
      label: "Request Timestamp",
      visible: false,
      type: CELL_TYPES.date,
    },
    { key: "Date", label: "Repay Date", visible: false, type: CELL_TYPES.date },
    { key: "OrderId", label: "Order Id", visible: true, type: CELL_TYPES.text },
  ];
}
